class TjekWidget {
    toggleButtons: NodeListOf<Element>;

    constructor() {
        this.toggleButtons = document.querySelectorAll(
            ".single-store__tjek-toggle-button",
        );
        this.init();
    }

    init() {
        if (this.toggleButtons.length > 0) {
            this.addListeners();
        }
    }

    addListeners() {
        const tabs: NodeListOf<HTMLElement> = document.querySelectorAll(
            ".single-store__tjek-tabs-wrapper button",
        );

        tabs.forEach((tab) =>
            tab.addEventListener("click", () => {
                const isSelected = tab.getAttribute("aria-selected") === "true";
                if (isSelected) return;

                tabs.forEach((t) => {
                    t.setAttribute("aria-selected", "false");
                    t.classList.remove("active");
                });

                tab.setAttribute("aria-selected", "true");
                tab.classList.add("active");

                const publicationId = tab.dataset.publicationId;

                document
                    .querySelector(
                        ".tjek-widget[data-type='publication-viewer']",
                    )!
                    .dispatchEvent(
                        new CustomEvent(
                            "tjek_widgets:publication_viewer:open",
                            {
                                detail: {
                                    payload: {
                                        id: publicationId,
                                    },
                                },
                            },
                        ),
                    );
            }),
        );
    }
}

export default TjekWidget;
